import { render } from "./ClientsThingsRequiringAttention.vue?vue&type=template&id=02c77b3c&scoped=true"
import script from "./ClientsThingsRequiringAttention.vue?vue&type=script&lang=js"
export * from "./ClientsThingsRequiringAttention.vue?vue&type=script&lang=js"

import "./ClientsThingsRequiringAttention.vue?vue&type=style&index=0&id=02c77b3c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c77b3c"]])

export default __exports__